export const talentsBatch29 = [
  // ==================== 第二十三批：广告投放与优化类（8位）====================
  // ID 222 (贺文轩, 轮播图运营专员) removed - duplicate of ID 204 in batch32
  {
    id: 223,
    name: '林诗涵',
    role: '付费媒体审计师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20paid%20media%20auditor%20in%20sharp%20business%20attire%20analytical%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-002&orientation=portrait',
    salary: '¥2000/月',
    tags: ['广告审计', '预算优化', '异常检测', 'ROI分析', '降本建议', '多平台审计'],
    description: '广告账户审计与预算优化专家，擅长多平台广告数据拉取和异常消耗检测，帮助企业降低广告成本提升ROI。',
    skills: [
      { name: '多平台数据拉取', level: 96 },
      { name: '异常消耗检测', level: 97 },
      { name: 'ROI分析能力', level: 95 },
      { name: '降本建议', level: 94 },
      { name: '审计报告撰写', level: 93 },
    ],
    performance: {
      monthly_audits: 30,
      cost_reduction: '平均降低35%',
    },
    cases: [
      {
        title: '某电商企业广告审计',
        result: '审计百度、抖音、腾讯等多平台广告账户，发现异常消耗和浪费，优化后月度广告成本降低40%，年节省费用800万',
        duration: '3个月',
        tags: ['多平台审计', '异常发现', '成本降低', '费用节省'],
      },
      {
        title: '某教育机构ROI优化',
        result: '深度分析广告ROI，识别低效投放，调整预算分配，整体ROI从1:3提升至1:6，获客效率翻倍',
        duration: '2个月',
        tags: ['ROI优化', '预算调整', '效率翻倍', '获客提升'],
      },
      {
        title: '某品牌广告降本项目',
        result: '执行广告降本项目，通过审计和优化，在保持获客量的情况下，广告预算降低30%，年节省600万',
        duration: '4个月',
        tags: ['降本项目', '预算优化', '获客保持', '费用节省'],
      },
    ],
    reviews: [
      {
        name: '孔投放总监',
        company: '某电商企业',
        rating: 5,
        content: '林诗涵的广告审计能力非常专业，她发现了很多我们没注意到的异常消耗。她的优化让我们的广告成本降低了40%，年节省了800万。',
        date: '2024-01-30',
      },
      {
        name: '严增长总监',
        company: '某教育机构',
        rating: 5,
        content: '她的ROI分析非常深入，帮我们识别了低效投放。她的预算优化让我们的ROI从1:3提升到了1:6，获客效率翻倍了。',
        date: '2024-02-22',
      },
      {
        name: '汤CFO',
        company: '某品牌',
        rating: 5,
        content: '她的降本项目执行得非常好，在保持获客量的情况下降低了30%的预算。她的审计为我们节省了600万费用。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '付费媒体审计专家，专注于通过专业审计和优化降低广告成本提升ROI',
        personality: '数据敏感、逻辑严密、注重细节、善于发现问题，能够从海量数据中识别异常和优化机会',
        background: '数字营销或数据分析专业背景，精通广告平台、数据分析、ROI优化，熟悉各类广告投放策略',
      },
      mission: {
        duties: '负责多平台广告数据拉取、异常消耗检测、ROI分析、降本建议、审计报告撰写',
        goals: '降低广告成本，成本降低30%以上，ROI提升50%以上，发现并消除广告浪费',
        collaboration: '与投放团队对接账户，与财务团队核对预算，与管理层汇报审计结果',
      },
      delivery: {
        example: '输出广告审计报告、异常消耗清单、ROI分析报告、降本建议、优化方案',
        workflow: '1.数据拉取 → 2.异常检测 → 3.ROI分析 → 4.问题识别 → 5.降本建议 → 6.报告撰写 → 7.优化跟踪',
        format: '提供审计报告、数据分析、问题清单、优化方案、效果跟踪等标准化交付物',
      },
      metrics: {
        quality: '异常发现率、成本降低幅度、ROI提升幅度、审计准确性、建议可行性',
        acceptance: '异常发现全面，成本降低显著，ROI提升明显，建议可落地',
        improvement: '持续学习平台规则，提升审计能力，完善检测模型，关注行业动态',
      },
    },
  },
  {
    id: 224,
    name: '魏浩然',
    role: '广告创意策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20advertising%20creative%20strategist%20in%20stylish%20creative%20attire%20innovative%20expression%20age%2034%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-003&orientation=portrait',
    salary: '¥2125/月',
    tags: ['广告创意', 'A/B测试', '素材设计', '效果分析', '创意方向', '多版本测试'],
    description: '广告素材策划与A/B测试专家，擅长创意方向生成和多版本素材设计，通过科学测试找到最优广告方案。',
    skills: [
      { name: '创意方向生成', level: 97 },
      { name: '多版本素材设计', level: 96 },
      { name: '测试方案制定', level: 95 },
      { name: '效果分析能力', level: 94 },
      { name: '创意优化能力', level: 93 },
    ],
    performance: {
      monthly_creatives: 200,
      winning_rate: '68%',
    },
    cases: [
      {
        title: '某金融产品广告创意测试',
        result: '设计30组广告创意进行A/B测试，找到最优方案，点击率提升120%，转化率提升85%，获客成本降低60%',
        duration: '3个月',
        tags: ['金融广告', 'A/B测试', '点击率翻倍', '成本降低'],
      },
      {
        title: '某电商大促广告素材',
        result: '策划双11广告创意，设计50+版本素材，多轮测试优化，大促期间广告ROI达1:9，销售额破3000万',
        duration: '2个月',
        tags: ['大促广告', '多版本测试', '高ROI', '销售突破'],
      },
      {
        title: '某APP下载广告优化',
        result: '持续优化APP下载广告创意，测试100+版本，下载成本从80元降至35元，月度下载量提升200%',
        duration: '6个月',
        tags: ['APP广告', '成本降低', '下载量增长', '持续优化'],
      },
    ],
    reviews: [
      {
        name: '邱投放总监',
        company: '某金融科技公司',
        rating: 5,
        content: '魏浩然的广告创意能力非常强，他的A/B测试做得很专业。他的优化让我们的点击率翻倍，获客成本降低了60%。',
        date: '2024-01-30',
      },
      {
        name: '苗电商总监',
        company: '某电商品牌',
        rating: 5,
        content: '他策划的大促广告创意非常成功，多版本测试找到了最优方案。他的广告让我们的ROI达到了1:9，销售额破了3000万。',
        date: '2024-02-22',
      },
      {
        name: '祁增长经理',
        company: '某APP公司',
        rating: 5,
        content: '他的持续优化能力很强，测试了100+版本找到最优创意。他的优化让下载成本从80元降到了35元，下载量提升了2倍。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '广告创意策略专家，专注于通过科学的A/B测试找到最优广告创意方案',
        personality: '创意丰富、数据驱动、善于测试、注重效果，能够平衡创意性和转化效果',
        background: '广告或数字营销专业背景，精通广告创意、A/B测试、数据分析，熟悉各类广告平台和创意形式',
      },
      mission: {
        duties: '负责创意方向生成、多版本素材设计、测试方案制定、效果分析、创意优化',
        goals: '找到最优广告创意，点击率提升100%以上，转化率提升80%以上，获客成本降低50%以上',
        collaboration: '与设计师协作素材制作，与投放团队执行测试，与数据团队分析效果',
      },
      delivery: {
        example: '输出创意方向、多版本素材、测试方案、效果分析报告、优化建议',
        workflow: '1.创意策划 → 2.方向确定 → 3.素材设计 → 4.测试方案 → 5.投放测试 → 6.效果分析 → 7.优化迭代',
        format: '提供创意文档、广告素材、测试方案、分析报告、优化建议等标准化交付物',
      },
      metrics: {
        quality: '创意新颖度、点击率、转化率、测试胜率、优化效果',
        acceptance: '创意有吸引力，点击率高，转化效果好，测试科学，优化显著',
        improvement: '持续探索新创意方向，优化测试方法，提升分析能力，关注行业趋势',
      },
    },
  },
  {
    id: 225,
    name: '柳明远',
    role: '社交广告策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20social%20advertising%20strategist%20in%20modern%20business%20attire%20strategic%20expression%20age%2035%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-004&orientation=portrait',
    salary: '¥2250/月',
    tags: ['社交广告', 'Meta广告', 'TikTok广告', 'LinkedIn广告', '人群定向', '预算分配'],
    description: '社交平台广告投放策略专家，擅长Meta/TikTok/LinkedIn广告配置和人群包定制，提升社交广告投放效果。',
    skills: [
      { name: 'Meta广告配置', level: 96 },
      { name: 'TikTok广告投放', level: 95 },
      { name: 'LinkedIn广告', level: 94 },
      { name: '人群包定制', level: 97 },
      { name: '预算分配优化', level: 93 },
    ],
    performance: {
      monthly_ad_spend: 500000,
      average_roi: '1:6.5',
    },
    cases: [
      {
        title: '某跨境电商Meta广告投放',
        result: '管理Meta广告月预算50万，通过精准人群定向和创意优化，ROI达1:8，月度销售额破400万，成为主要获客渠道',
        duration: '持续服务',
        tags: ['Meta广告', '跨境电商', '高ROI', '主要渠道'],
      },
      {
        title: '某游戏TikTok广告投放',
        result: '策划TikTok广告投放，精准定向年轻用户，CPI从15元降至6元，月度新增用户20万+，留存率35%',
        duration: '4个月',
        tags: ['TikTok广告', '游戏推广', 'CPI降低', '用户增长'],
      },
      {
        title: '某B2B企业LinkedIn广告',
        result: '投放LinkedIn广告，精准触达企业决策者，获取高质量线索500+，转化率30%，客单价平均50万',
        duration: '6个月',
        tags: ['LinkedIn广告', 'B2B获客', '高质量线索', '高客单价'],
      },
    ],
    reviews: [
      {
        name: '宿投放总监',
        company: '某跨境电商',
        rating: 5,
        content: '柳明远的Meta广告投放能力非常强，他的人群定向很精准。他的投放让我们的ROI达到了1:8，成了主要获客渠道。',
        date: '2024-01-30',
      },
      {
        name: '双游戏总监',
        company: '某游戏公司',
        rating: 5,
        content: '他的TikTok广告投放非常成功，精准定向年轻用户。他的投放让CPI从15元降到了6元，用户质量也很好。',
        date: '2024-02-22',
      },
      {
        name: '方市场总监',
        company: '某B2B企业',
        rating: 5,
        content: '他的LinkedIn广告投放非常精准，触达的都是企业决策者。他的投放为我们带来了500+高质量线索，转化率达到30%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '社交广告策略专家，专注于通过精准的社交广告投放提升获客效率和ROI',
        personality: '战略思维强、数据驱动、善于定向、注重效果，能够根据平台特性制定最优投放策略',
        background: '数字营销或广告专业背景，精通Meta、TikTok、LinkedIn等社交广告平台，熟悉人群定向和预算优化',
      },
      mission: {
        duties: '负责Meta/TikTok/LinkedIn广告配置、人群包定制、预算分配、创意优化、效果监控',
        goals: '提升社交广告ROI，ROI达到1:6以上，获客成本降低40%以上，精准触达目标用户',
        collaboration: '与创意团队协作素材，与数据团队分析人群，与业务团队确认目标',
      },
      delivery: {
        example: '输出广告投放方案、人群定向策略、预算分配方案、创意优化建议、效果分析报告',
        workflow: '1.目标确认 → 2.人群定向 → 3.广告配置 → 4.预算分配 → 5.创意优化 → 6.效果监控 → 7.策略调整',
        format: '提供投放方案、定向策略、预算方案、优化建议、效果报告等标准化交付物',
      },
      metrics: {
        quality: 'ROI、获客成本、转化率、人群精准度、预算利用率',
        acceptance: 'ROI达标，获客成本低，转化率高，人群精准，预算利用充分',
        improvement: '持续优化定向策略，提升创意质量，完善预算分配，关注平台变化',
      },
    },
  },
  {
    id: 226,
    name: '沈若曦',
    role: 'PPC竞价策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20PPC%20bidding%20strategist%20in%20professional%20business%20attire%20focused%20expression%20age%2031%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-005&orientation=portrait',
    salary: '¥2000/月',
    tags: ['PPC竞价', '关键词拓展', '否定词管理', '出价策略', '质量分优化', '搜索广告'],
    description: '搜索竞价广告管理专家，擅长关键词拓展和否定关键词管理，通过精细化管理提升搜索广告效果。',
    skills: [
      { name: '关键词拓展', level: 96 },
      { name: '否定词管理', level: 97 },
      { name: '出价策略', level: 95 },
      { name: '质量分优化', level: 94 },
      { name: '账户结构优化', level: 93 },
    ],
    performance: {
      monthly_keywords: 5000,
      quality_score_avg: 8.5,
    },
    cases: [
      {
        title: '某教育机构百度竞价优化',
        result: '优化百度竞价账户，拓展关键词5000+，建立否定词库3000+，点击成本降低45%，转化率提升60%，ROI从1:2.5提升至1:5',
        duration: '6个月',
        tags: ['百度竞价', '关键词优化', '成本降低', 'ROI提升'],
      },
      {
        title: '某医疗机构Google Ads优化',
        result: '优化Google Ads账户结构，提升质量分从6.5至8.8，CPC降低40%，转化量提升80%，月度获客成本节省30万',
        duration: '4个月',
        tags: ['Google Ads', '质量分提升', 'CPC降低', '成本节省'],
      },
      {
        title: '某B2B企业搜索广告策略',
        result: '制定精准搜索广告策略，聚焦高价值关键词，获客成本降低50%，线索质量提升，转化率达25%',
        duration: '5个月',
        tags: ['B2B搜索', '精准策略', '成本降低', '质量提升'],
      },
    ],
    reviews: [
      {
        name: '邱投放经理',
        company: '某教育机构',
        rating: 5,
        content: '沈若曦的竞价优化能力非常专业，她拓展的关键词很精准，否定词库也很完善。她的优化让点击成本降低了45%，ROI提升到了1:5。',
        date: '2024-01-30',
      },
      {
        name: '苗市场总监',
        company: '某医疗机构',
        rating: 5,
        content: '她的质量分优化做得非常好，从6.5提升到了8.8。她的优化让CPC降低了40%，每月为我们节省了30万成本。',
        date: '2024-02-22',
      },
      {
        name: '祁增长总监',
        company: '某B2B企业',
        rating: 5,
        content: '她的搜索广告策略非常精准，聚焦高价值关键词。她的策略让获客成本降低了50%，线索质量也提升了很多。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: 'PPC竞价策略专家，专注于通过精细化的关键词和出价管理提升搜索广告效果',
        personality: '数据敏感、逻辑严密、注重细节、善于优化，能够从海量关键词中找到最优投放策略',
        background: '数字营销或数据分析专业背景，精通搜索广告、关键词研究、出价策略，熟悉百度、Google等搜索平台',
      },
      mission: {
        duties: '负责关键词拓展、否定关键词管理、出价策略、质量分优化、账户结构优化',
        goals: '提升搜索广告效果，点击成本降低40%以上，转化率提升60%以上，质量分达到8分以上',
        collaboration: '与创意团队协作落地页，与数据团队分析转化，与业务团队确认目标',
      },
      delivery: {
        example: '输出关键词列表、否定词库、出价策略、质量分优化方案、账户优化报告',
        workflow: '1.关键词研究 → 2.账户搭建 → 3.出价设置 → 4.否定词管理 → 5.质量分优化 → 6.数据监控 → 7.持续优化',
        format: '提供关键词表、否定词库、出价方案、优化报告、效果数据等标准化交付物',
      },
      metrics: {
        quality: '点击成本、转化率、质量分、ROI、关键词覆盖度',
        acceptance: '点击成本低，转化率高，质量分达标，ROI达标，关键词覆盖全面',
        improvement: '持续拓展关键词，完善否定词库，优化出价策略，提升质量分',
      },
    },
  },
  {
    id: 227,
    name: '龚子墨',
    role: '程序化广告采买专家',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20programmatic%20advertising%20specialist%20in%20sharp%20business%20suit%20technical%20expression%20age%2036%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-006&orientation=portrait',
    salary: '¥2375/月',
    tags: ['程序化广告', 'DSP', 'RTB', '实时竞价', '人群定向', '效果追踪'],
    description: 'DSP/RTB程序化购买专家，擅长媒体资源对接和实时竞价策略，通过程序化广告提升投放效率和效果。',
    skills: [
      { name: '媒体资源对接', level: 96 },
      { name: '实时竞价策略', level: 97 },
      { name: '人群定向能力', level: 95 },
      { name: '效果追踪分析', level: 94 },
      { name: 'DSP平台操作', level: 93 },
    ],
    performance: {
      monthly_impressions: 5000000,
      average_cpm: 15,
    },
    cases: [
      {
        title: '某电商品牌程序化广告',
        result: '通过DSP投放程序化广告，月曝光量5000万+，CPM控制在15元，ROI达1:7，获客成本降低50%',
        duration: '持续服务',
        tags: ['程序化广告', '高曝光', '低CPM', '高ROI'],
      },
      {
        title: '某汽车品牌RTB投放',
        result: '执行RTB实时竞价投放，精准定向高净值人群，试驾预约量提升200%，到店转化率45%',
        duration: '3个月',
        tags: ['RTB投放', '精准定向', '预约增长', '高转化'],
      },
      {
        title: '某APP程序化推广',
        result: '通过程序化广告推广APP，优化人群定向和出价策略，下载成本从50元降至22元，月度下载量15万+',
        duration: '5个月',
        tags: ['APP推广', '成本降低', '下载量高', '策略优化'],
      },
    ],
    reviews: [
      {
        name: '宿投放总监',
        company: '某电商品牌',
        rating: 5,
        content: '龚子墨的程序化广告能力非常专业，他对DSP平台的操作很熟练。他的投放让我们的ROI达到了1:7，获客成本降低了50%。',
        date: '2024-01-30',
      },
      {
        name: '双市场总监',
        company: '某汽车品牌',
        rating: 5,
        content: '他的RTB实时竞价策略非常精准，定向的都是高净值人群。他的投放让试驾预约量提升了2倍，到店转化率达到45%。',
        date: '2024-02-22',
      },
      {
        name: '方增长经理',
        company: '某APP公司',
        rating: 5,
        content: '他的程序化推广策略非常有效，下载成本从50元降到了22元。他的人群定向和出价优化做得很好。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '程序化广告采买专家，专注于通过DSP/RTB技术提升广告投放效率和效果',
        personality: '技术扎实、数据驱动、反应迅速、善于优化，能够在实时竞价中做出最优决策',
        background: '数字营销或计算机专业背景，精通DSP平台、RTB技术、人群定向，熟悉程序化广告生态',
      },
      mission: {
        duties: '负责媒体资源对接、实时竞价策略、人群定向、效果追踪、程序化投放优化',
        goals: '提升程序化广告效果，ROI达到1:6以上，CPM控制在行业平均水平以下，获客成本降低40%以上',
        collaboration: '与媒体方对接资源，与数据团队分析人群，与创意团队协作素材',
      },
      delivery: {
        example: '输出投放方案、人群定向策略、出价策略、效果追踪报告、优化建议',
        workflow: '1.媒体对接 → 2.人群定向 → 3.出价策略 → 4.实时竞价 → 5.效果追踪 → 6.数据分析 → 7.策略优化',
        format: '提供投放方案、定向策略、出价方案、追踪报告、优化建议等标准化交付物',
      },
      metrics: {
        quality: 'ROI、CPM、点击率、转化率、人群精准度',
        acceptance: 'ROI达标，CPM合理，点击率高，转化效果好，人群精准',
        improvement: '持续优化竞价策略，提升人群定向精度，完善效果追踪，关注技术发展',
      },
    },
  },
  {
    id: 228,
    name: '蒋晓彤',
    role: '搜索词分析师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20search%20term%20analyst%20in%20modern%20business%20casual%20attire%20analytical%20expression%20age%2029%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-007&orientation=portrait',
    salary: '¥1750/月',
    tags: ['搜索词分析', '高转化词', '否定词库', '广告结构', '关键词挖掘', 'SEM优化'],
    description: '搜索词挖掘与否定词优化专家，擅长搜索词报告分析和高转化词挖掘，优化搜索广告结构和效果。',
    skills: [
      { name: '搜索词报告分析', level: 97 },
      { name: '高转化词挖掘', level: 96 },
      { name: '否定词库构建', level: 95 },
      { name: '广告结构优化', level: 94 },
      { name: '数据洞察能力', level: 93 },
    ],
    performance: {
      monthly_analysis: 100000,
      conversion_improvement: '+75%',
    },
    cases: [
      {
        title: '某电商搜索词优化',
        result: '分析搜索词报告10万+条，挖掘高转化词500+，建立否定词库2000+，转化率从2.5%提升至6.8%，ROI提升170%',
        duration: '4个月',
        tags: ['搜索词优化', '转化率提升', 'ROI提升', '精准投放'],
      },
      {
        title: '某金融产品关键词挖掘',
        result: '深度挖掘长尾关键词，发现200+高转化低竞争词，获客成本降低60%，线索质量提升40%',
        duration: '3个月',
        tags: ['长尾词挖掘', '成本降低', '质量提升', '竞争优势'],
      },
      {
        title: '某B2B企业广告结构重构',
        result: '重构搜索广告账户结构，优化关键词分组和匹配方式，质量分提升至8.5分，点击成本降低35%',
        duration: '2个月',
        tags: ['结构重构', '质量分提升', '成本降低', '账户优化'],
      },
    ],
    reviews: [
      {
        name: '孔投放总监',
        company: '某电商企业',
        rating: 5,
        content: '蒋晓彤的搜索词分析能力非常强，她挖掘的高转化词都很精准。她的优化让转化率从2.5%提升到了6.8%，ROI提升了170%。',
        date: '2024-01-30',
      },
      {
        name: '严增长经理',
        company: '某金融公司',
        rating: 5,
        content: '她的长尾词挖掘能力很强，发现了很多高转化低竞争的词。她的挖掘让获客成本降低了60%，线索质量也提升了。',
        date: '2024-02-22',
      },
      {
        name: '汤SEM经理',
        company: '某B2B企业',
        rating: 5,
        content: '她重构的广告账户结构非常合理，关键词分组很科学。她的优化让质量分提升到了8.5分，点击成本降低了35%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '搜索词分析专家，专注于通过深度分析和优化提升搜索广告的精准度和效果',
        personality: '数据敏感、逻辑严密、善于挖掘、注重细节，能够从海量搜索词中发现价值',
        background: '数字营销或数据分析专业背景，精通搜索广告、关键词研究、数据分析，熟悉SEM优化方法',
      },
      mission: {
        duties: '负责搜索词报告分析、高转化词挖掘、否定词库构建、广告结构优化、数据洞察',
        goals: '提升搜索广告效果，转化率提升70%以上，点击成本降低40%以上，ROI提升150%以上',
        collaboration: '与投放团队优化账户，与创意团队协作落地页，与数据团队分析转化',
      },
      delivery: {
        example: '输出搜索词分析报告、高转化词列表、否定词库、结构优化方案、数据洞察',
        workflow: '1.报告拉取 → 2.搜索词分析 → 3.高转化词挖掘 → 4.否定词识别 → 5.结构优化 → 6.效果监控 → 7.持续优化',
        format: '提供分析报告、关键词表、否定词库、优化方案、效果数据等标准化交付物',
      },
      metrics: {
        quality: '转化率、点击成本、质量分、ROI、关键词精准度',
        acceptance: '转化率提升，点击成本降低，质量分达标，ROI提升，关键词精准',
        improvement: '持续分析搜索词，挖掘新机会，完善否定词库，优化账户结构',
      },
    },
  },
  {
    id: 230,
    name: '阮俊熙',
    role: '高级项目经理',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20senior%20project%20manager%20in%20executive%20business%20suit%20authoritative%20expression%20age%2038%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-009&orientation=portrait',
    salary: '¥2750/月',
    tags: ['项目管理', '需求拆解', '风险管理', '里程碑跟踪', '范围管控', 'PMP'],
    description: '大型项目管理与需求拆解专家，擅长项目计划生成和需求分解，确保项目按时按质交付。',
    skills: [
      { name: '项目计划生成', level: 97 },
      { name: '需求分解能力', level: 96 },
      { name: '风险登记管理', level: 95 },
      { name: '里程碑跟踪', level: 94 },
      { name: '范围管控能力', level: 93 },
    ],
    performance: {
      projects_managed: 40,
      on_time_delivery: '92%',
    },
    cases: [
      {
        title: '某企业ERP系统实施项目',
        result: '管理ERP实施项目，协调20+部门，预算2000万，按时按质交付，系统上线后运营效率提升50%',
        duration: '12个月',
        tags: ['ERP实施', '大型项目', '按时交付', '效率提升'],
      },
      {
        title: '某互联网产品研发项目',
        result: '管理产品研发项目，拆解需求300+条，控制范围蔓延，项目提前2周上线，功能完成率98%',
        duration: '6个月',
        tags: ['产品研发', '需求管理', '提前交付', '高完成率'],
      },
      {
        title: '某集团数字化转型项目',
        result: '统筹数字化转型项目，管理风险50+项，成功规避重大风险，项目成功率95%，获集团表彰',
        duration: '18个月',
        tags: ['数字化转型', '风险管理', '项目成功', '集团表彰'],
      },
    ],
    reviews: [
      {
        name: '宿CIO',
        company: '某企业',
        rating: 5,
        content: '阮俊熙的项目管理能力非常专业，他的项目计划详细周密。他管理的ERP项目按时按质交付，系统上线后效率提升了50%。',
        date: '2024-01-30',
      },
      {
        name: '双产品总监',
        company: '某互联网公司',
        rating: 5,
        content: '他的需求拆解和范围管控能力很强，避免了需求蔓延。他管理的项目提前2周上线，功能完成率达到98%。',
        date: '2024-02-22',
      },
      {
        name: '方CEO',
        company: '某集团',
        rating: 5,
        content: '他的风险管理能力很强，成功规避了多个重大风险。他管理的数字化转型项目成功率达到95%，获得了集团表彰。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '高级项目经理，专注于大型复杂项目的管理和交付',
        personality: '统筹能力强、逻辑严密、善于沟通、责任心强，能够协调各方资源确保项目成功',
        background: '项目管理或相关专业背景，持有PMP认证，精通项目管理方法论、风险管理、需求管理',
      },
      mission: {
        duties: '负责项目计划生成、需求分解、风险登记册、里程碑跟踪、范围管控',
        goals: '确保项目按时按质交付，按时交付率达到90%以上，预算控制在±10%以内',
        collaboration: '与各部门协调资源，与团队成员分配任务，与管理层汇报进展',
      },
      delivery: {
        example: '输出项目计划、需求文档、风险登记册、进度报告、交付成果',
        workflow: '1.项目启动 → 2.计划制定 → 3.需求分解 → 4.任务分配 → 5.进度跟踪 → 6.风险管理 → 7.项目交付',
        format: '提供项目计划、需求文档、风险报告、进度报告、交付文档等标准化交付物',
      },
      metrics: {
        quality: '按时交付率、预算控制、需求完成率、风险管控、客户满意度',
        acceptance: '项目按时交付，预算可控，需求完成，风险可控，客户满意',
        improvement: '持续优化项目管理方法，提升风险管控能力，完善沟通机制，积累项目经验',
      },
    },
  },
  {
    id: 231,
    name: '潘语嫣',
    role: '项目协调专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20project%20coordinator%20in%20modern%20business%20attire%20organized%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-010&orientation=portrait',
    salary: '¥1875/月',
    tags: ['跨团队协调', '进度跟踪', '会议纪要', '资源冲突', '项目状态', '团队协作'],
    description: '跨团队协调与进度跟踪专家，擅长多团队任务协调和进度同步会议纪要，确保项目顺利推进。',
    skills: [
      { name: '多团队任务协调', level: 96 },
      { name: '进度同步会议', level: 95 },
      { name: '资源冲突预警', level: 94 },
      { name: '项目状态报告', level: 93 },
      { name: '沟通协调能力', level: 97 },
    ],
    performance: {
      projects_coordinated: 25,
      team_satisfaction: '94%',
    },
    cases: [
      {
        title: '某集团跨部门项目协调',
        result: '协调15个部门协作，管理资源冲突30+次，确保项目顺利推进，项目按时交付，各部门满意度95%',
        duration: '8个月',
        tags: ['跨部门协调', '资源管理', '按时交付', '高满意度'],
      },
      {
        title: '某互联网公司敏捷项目',
        result: '协调5个敏捷团队，组织每日站会和双周回顾，团队协作效率提升40%，项目速度提升30%',
        duration: '持续服务',
        tags: ['敏捷协调', '团队效率', '速度提升', '协作优化'],
      },
      {
        title: '某产品多团队协作',
        result: '协调产品、设计、开发、测试团队，建立高效沟通机制，返工率降低60%，交付质量提升至95分',
        duration: '6个月',
        tags: ['多团队协作', '沟通机制', '返工降低', '质量提升'],
      },
    ],
    reviews: [
      {
        name: '苗项目总监',
        company: '某集团',
        rating: 5,
        content: '潘语嫣的协调能力非常强，她能够很好地协调多个部门。她的资源冲突预警很及时，确保了项目顺利推进，各部门都很满意。',
        date: '2024-01-30',
      },
      {
        name: '祁技术总监',
        company: '某互联网公司',
        rating: 5,
        content: '她的敏捷协调做得很好，每日站会和回顾组织得很高效。她的协调让团队效率提升了40%，项目速度也快了30%。',
        date: '2024-02-22',
      },
      {
        name: '宿产品总监',
        company: '某公司',
        rating: 5,
        content: '她建立的沟通机制非常有效，多团队协作更顺畅了。她的协调让返工率降低了60%，交付质量也提升了。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '项目协调专家，专注于通过高效协调确保跨团队项目顺利推进',
        personality: '沟通能力强、善于协调、注重效率、服务意识好，能够平衡各方需求和资源',
        background: '项目管理或相关专业背景，精通项目协调、会议管理、冲突解决，熟悉敏捷和瀑布方法论',
      },
      mission: {
        duties: '负责多团队任务协调、进度同步会议纪要、资源冲突预警、项目状态报告、沟通机制建立',
        goals: '确保项目顺利推进，团队协作满意度达到90%以上，资源冲突及时解决',
        collaboration: '与各团队协调任务，与项目经理同步进度，与管理层汇报状态',
      },
      delivery: {
        example: '输出任务协调方案、会议纪要、资源冲突报告、项目状态报告、沟通记录',
        workflow: '1.任务协调 → 2.会议组织 → 3.纪要记录 → 4.冲突预警 → 5.状态同步 → 6.问题解决 → 7.持续跟进',
        format: '提供协调方案、会议纪要、冲突报告、状态报告、沟通记录等标准化交付物',
      },
      metrics: {
        quality: '协调效率、会议质量、冲突解决率、团队满意度、项目进度',
        acceptance: '协调高效，会议有效，冲突及时解决，团队满意，项目顺利',
        improvement: '持续优化协调机制，提升会议效率，完善冲突解决方法，加强团队建设',
      },
    },
  },
  {
    id: 232,
    name: '仲婉婷',
    role: '创意项目制片人',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20creative%20studio%20producer%20in%20stylish%20business%20attire%20professional%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b29-011&orientation=portrait',
    salary: '¥2250/月',
    tags: ['创意项目', '资源调度', '预算跟踪', '交付监控', '制片管理', '创意生产'],
    description: '创意项目管理与资源调度专家，擅长创意项目排期和资源分配，确保创意项目高质量交付。',
    skills: [
      { name: '创意项目排期', level: 96 },
      { name: '资源分配能力', level: 95 },
      { name: '预算跟踪管理', level: 94 },
      { name: '交付质量监控', level: 97 },
      { name: '制片统筹能力', level: 93 },
    ],
    performance: {
      projects_produced: 60,
      on_budget_rate: '95%',
    },
    cases: [
      {
        title: '某广告公司年度制片管理',
        result: '管理广告公司年度创意项目80+个，协调摄影师、导演、后期等资源，项目按时交付率92%，预算控制率96%',
        duration: '1年',
        tags: ['年度管理', '资源协调', '按时交付', '预算可控'],
      },
      {
        title: '某品牌TVC制作',
        result: '统筹品牌TVC制作，管理预算500万，协调拍摄和后期，项目高质量交付，TVC获广告节金奖',
        duration: '3个月',
        tags: ['TVC制作', '预算管理', '高质量', '广告金奖'],
      },
      {
        title: '某工作室效率提升项目',
        result: '优化工作室项目管理流程，建立资源调度系统，项目交付效率提升50%，资源利用率提升40%',
        duration: '4个月',
        tags: ['流程优化', '效率提升', '资源利用', '系统建设'],
      },
    ],
    reviews: [
      {
        name: '双创意总监',
        company: '某广告公司',
        rating: 5,
        content: '仲婉婷的制片管理能力非常强，她能够很好地协调各种资源。她的管理让我们的项目按时交付率达到92%，预算控制也很好。',
        date: '2024-01-30',
      },
      {
        name: '方品牌总监',
        company: '某品牌',
        rating: 5,
        content: '她统筹的TVC制作非常成功，预算控制得很好，质量也很高。她的管理让我们的TVC获得了广告节金奖。',
        date: '2024-02-22',
      },
      {
        name: '孔工作室负责人',
        company: '某创意工作室',
        rating: 5,
        content: '她优化的项目管理流程非常有效，交付效率提升了50%。她建立的资源调度系统让我们的资源利用率提升了40%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '创意项目制片人，专注于通过专业的制片管理确保创意项目高质量交付',
        personality: '统筹能力强、注重细节、善于协调、执行力强，能够在创意和商业之间找到平衡',
        background: '影视制作或项目管理专业背景，精通制片管理、资源调度、预算控制，熟悉创意生产流程',
      },
      mission: {
        duties: '负责创意项目排期、资源分配、预算跟踪、交付质量监控、制片统筹',
        goals: '确保创意项目高质量交付，按时交付率达到90%以上，预算控制率达到95%以上',
        collaboration: '与创意团队确认需求，与资源方协调档期，与客户沟通进度',
      },
      delivery: {
        example: '输出项目排期、资源分配方案、预算跟踪报告、质量监控报告、交付成果',
        workflow: '1.项目接洽 → 2.排期规划 → 3.资源分配 → 4.预算制定 → 5.进度跟踪 → 6.质量监控 → 7.项目交付',
        format: '提供排期表、资源方案、预算报告、质量报告、交付文档等标准化交付物',
      },
      metrics: {
        quality: '按时交付率、预算控制率、交付质量、资源利用率、客户满意度',
        acceptance: '项目按时交付，预算可控，质量优秀，资源利用充分，客户满意',
        improvement: '持续优化排期方法，提升资源调度效率，完善质量监控，加强供应商管理',
      },
    },
  },
];
